import { gql } from '@apollo/client';

// 审核司机信息
export const REVIEW_DRIVER_VERIFICATION = gql`
    mutation ReviewDriverVerification(
        $driverAccountId: Long!,
        $reviewResult: DriverVerificationReviewResultType!,
        $reviewComment: String
    ) {
        reviewDriverVerification(
            driverAccountId: $driverAccountId,
            reviewResult: $reviewResult,
            reviewComment: $reviewComment
        ) {
            success
            driverAccountId
            newStatus
            verificationTime
        }
    }
`;

